import { Component } from 'react';
import { callIfPossible } from '../../utils/functions';
import { getDefaultNode } from '../../utils/RootNode';
import { PortalLayer } from '../PortalLayer/PortalLayer';
import { ResetContext } from '../../context/ResetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export class Layer extends Component {
  constructor(props) {
    super(props);
    this.handleCloseComplete = () => {
      const {
        onCloseComplete,
        transitionProps
      } = this.props;
      callIfPossible(transitionProps && transitionProps.onCloseComplete);
      callIfPossible(onCloseComplete);
      this._rootNode.removeChild(this._element);
    };
    this.renderTree = content => {
      const {
        Transition,
        transitionProps
      } = this.props;
      if (!Transition) return content;
      return /*#__PURE__*/_jsx(Transition, Object.assign({}, transitionProps, {
        onCloseComplete: this.handleCloseComplete,
        transitionOnMount: transitionProps && transitionProps.transitionOnMount,
        children: content
      }));
    };
    this._rootNode = props.rootNode || getDefaultNode();
    this._element = document.createElement('div');
    // this._element.className = 'private-layer';
    if (props['data-layer-for']) {
      this._element.setAttribute('data-layer-for', props['data-layer-for']);
    }
    if (props['data-test-id']) {
      this._element.setAttribute('data-test-id', props['data-test-id']);
    }
    this._rootNode.appendChild(this._element);
  }
  componentWillUnmount() {
    const {
      Transition
    } = this.props;
    if (!Transition) this.handleCloseComplete();
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(ResetContext, {
      children: /*#__PURE__*/_jsx(PortalLayer, {
        element: this._element,
        renderTree: this.renderTree,
        children: children
      })
    });
  }
}
Layer.displayName = 'Layer';